import { render, staticRenderFns } from "./PlannerAssignStudent.vue?vue&type=template&id=0372586b&scoped=true"
import script from "./PlannerAssignStudent.vue?vue&type=script&lang=js"
export * from "./PlannerAssignStudent.vue?vue&type=script&lang=js"
import style0 from "./PlannerAssignStudent.vue?vue&type=style&index=0&id=0372586b&prod&scoped=true&lang=css"
import style1 from "./PlannerAssignStudent.vue?vue&type=style&index=1&id=0372586b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0372586b",
  null
  
)

export default component.exports